import React from 'react';
import Card from '@/components/Card/Card';
import CardBody from '@/components/Card/CardBody';
import GridContainer from '@/components/Grid/GridContainer';
import GridItem from '@/components/Grid/GridItem';
import CustomInput from '@/components/CustomInput/CustomInput';
import Button from '@/components/CustomButtons/Button';
import FieldErrorText, {
  fieldErrorHelperText,
} from '@/components/FieldErrorText/FieldErrorText';
import FormErrorSummary from '@/components/FormErrorSummary/FormErrorSummary';
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Switch,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';

const labelStyle = {
  fontSize: '12px',
  color: 'grey',
  cursor: 'pointer',
};

export default function SftpPickUp({
  formValues,
  setUpdatingBlocks,
  updatingBlocks,
  editId,
  isUpdating,
  onSftpConfigurationCancel,
  updateSftpConfiguration,
  handleInputChange,
  sftpConnections,
  fieldErrors = {},
  getFieldErrors = () => [],
  generalErrors = [],
}) {
  return (
    <Card className='dashboardCard table_card_height'>
      <CardBody
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          height: '100%',
        }}>
        <span style={{ display: 'flex', alignItems: 'center' }}>
          <h3 className='subHeading'>SFTP Pick Up</h3>
          <Switch
            name='is_sftp_enabled'
            checked={formValues.is_sftp_enabled}
            disabled={!isUpdating('sftp-configuration')}
            onChange={(value) =>
              handleInputChange({
                target: {
                  name: 'is_sftp_enabled',
                  value: value.target.checked,
                },
              })
            }
          />
        </span>
        <FormErrorSummary errors={generalErrors} />
        <FieldErrorText messages={getFieldErrors('is_sftp_enabled')} />
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <div className='custom-select'>
              <FormControl
                variant='standard'
                fullWidth
                error={!!fieldErrors.client_sftp_connection_id}>
                <InputLabel id='sftp-connection-label'>
                  SFTP Connection
                </InputLabel>
                <Select
                  disabled={!isUpdating('sftp-configuration')}
                  labelId='sftp-connection-label'
                  id='sftp-connection'
                  name='client_sftp_connection_id'
                  value={formValues.client_sftp_connection_id || ''}
                  onChange={handleInputChange}
                  className='full-width-elem'>
                  <MenuItem value=''>
                    <em>None</em>
                  </MenuItem>
                  {sftpConnections?.map((conn) => (
                    <MenuItem key={conn.id} value={conn.id}>
                      {conn.name || conn.host}
                    </MenuItem>
                  ))}
                </Select>
                <FieldErrorText
                  messages={getFieldErrors('client_sftp_connection_id')}
                />
              </FormControl>
            </div>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <CustomInput
              type='text'
              labelText='Folder location for file pickup'
              disabled={!isUpdating('sftp-configuration')}
              onChange={handleInputChange}
              value={formValues.file_source}
              name='file_source'
              formControlProps={{ fullWidth: true }}
              error={!!fieldErrors.file_source}
              inputProps={{
                helperText: fieldErrorHelperText(getFieldErrors('file_source')),
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <CustomInput
              type='text'
              labelText='Folder location to move processed File'
              onChange={handleInputChange}
              disabled={!isUpdating('sftp-configuration')}
              value={formValues.file_destination}
              name='file_destination'
              formControlProps={{ fullWidth: true }}
              error={!!fieldErrors.file_destination}
              inputProps={{
                helperText: fieldErrorHelperText(
                  getFieldErrors('file_destination'),
                ),
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <CustomInput
              type='text'
              labelText='File extension that will be picked up'
              onChange={handleInputChange}
              disabled={!isUpdating('sftp-configuration')}
              value={formValues.sftp_file_extension}
              name='sftp_file_extension'
              formControlProps={{ fullWidth: true }}
              error={!!fieldErrors.sftp_file_extension}
              inputProps={{
                helperText: fieldErrorHelperText(
                  getFieldErrors('sftp_file_extension'),
                ),
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                minHeight: '100%',
              }}>
              <FormControl error={!!fieldErrors.is_encrypted}>
                <FormLabel
                  style={labelStyle}
                  id='demo-row-radio-buttons-group-label'>
                  Is the file encrypted?
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby='demo-row-radio-buttons-group-label'
                  name='is_encrypted'
                  value={formValues.is_encrypted}
                  onChange={handleInputChange}>
                  <FormControlLabel
                    value='true'
                    disabled={!isUpdating('sftp-configuration')}
                    control={<Radio />}
                    label='Yes'
                  />
                  <FormControlLabel
                    value='false'
                    disabled={!isUpdating('sftp-configuration')}
                    control={<Radio />}
                    label='No'
                  />
                </RadioGroup>
                <FieldErrorText messages={getFieldErrors('is_encrypted')} />
              </FormControl>
            </div>
          </GridItem>
        </GridContainer>
        {editId && !updatingBlocks.includes('sftp-configuration') && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginTop: '20px',
            }}>
            <Button
              style={{ marginTop: '10px', marginBottom: '-10px' }}
              onClick={() =>
                setUpdatingBlocks([...updatingBlocks, 'sftp-configuration'])
              }
              color='primary'>
              Edit
            </Button>
          </div>
        )}
        {updatingBlocks.includes('sftp-configuration') && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginTop: '20px',
            }}>
            <Button
              style={{ marginTop: '10px', marginBottom: '-10px' }}
              onClick={onSftpConfigurationCancel}
              color='danger'>
              Cancel
            </Button>
            <Button
              style={{ marginTop: '10px', marginBottom: '-10px' }}
              onClick={updateSftpConfiguration}
              color='primary'>
              Save SFTP Configuration
            </Button>
          </div>
        )}
      </CardBody>
    </Card>
  );
}
